import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE } from "@/data/site";

const DEFAULT_TITLE = "Bursa Masaj Salonu | Diamond Life Premium Spa Nilüfer";

export default function SEO({ title, description, path = "/", image, schema, breadcrumb }) {
  // Always prepend "Bursa Masaj Salonu" branding
  const fullTitle = title
    ? `${title} | Bursa Masaj Salonu — Diamond Life`
    : DEFAULT_TITLE;
  const desc = description || SITE.description;
  const url = `${SITE.baseUrl}${path}`;
  const img = image || "https://images.unsplash.com/photo-1540555700478-4be289fbecef?auto=format&fit=crop&w=1600&q=80";

  // Auto-generate breadcrumb schema if provided
  const breadcrumbSchema = breadcrumb
    ? {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumb.map((b, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: b.name,
          item: `${SITE.baseUrl}${b.path}`,
        })),
      }
    : null;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content="bursa masaj salonu, masaj bursa, bursa spa, nilüfer masaj salonu, bursa masaj merkezi, aromaterapi bursa, medikal masaj bursa, sıcak taş masajı bursa, çift masajı bursa, bali masajı bursa, klasik masaj bursa, diamond life masaj" />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:site_name" content="Bursa Masaj Salonu — Diamond Life" />
      <meta property="og:locale" content="tr_TR" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
      {breadcrumbSchema && <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>}
    </Helmet>
  );
}
